import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X, Phone } from "lucide-react";
import { Link } from "react-router-dom";
import { CONTACT } from "@/data";

const LINKS = [
  { label: "Why Us", href: "/#benefits" },
  { label: "Process", href: "/#process" },
  { label: "Results", href: "/#gallery" },
  { label: "Add-Ons", href: "/#services" },
  { label: "Reviews", href: "/#reviews" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-colors duration-300 ${
        scrolled ? "bg-paper/95 border-b border-ink/10 backdrop-blur" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-20 flex items-center justify-between">
        <a href="#top" data-testid="nav-logo" className="flex items-center group">
          <img src="/logo.png" alt="Garage Cleaners" width="440" height="161" className="h-12 lg:h-14 w-auto" />
        </a>

        <nav className="hidden md:flex items-center gap-9">
          {LINKS.map((l) => (
            <a key={l.href} href={l.href} data-testid={`nav-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className="text-sm font-medium text-ink/70 hover:text-ink transition-colors">
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-4">
          <a href={CONTACT.phoneHref} data-testid="nav-phone"
            className="inline-flex items-center gap-2 text-rust font-display font-bold text-lg hover:opacity-80 transition-opacity">
            <Phone size={18} className="fill-rust" /> {CONTACT.phone}
          </a>
          <Link to="/estimate" data-testid="nav-cta"
            className="inline-flex items-center bg-ink text-paper px-5 py-2.5 text-sm font-semibold hover:bg-rust transition-colors">
            Free Estimate
          </Link>
        </div>

        <button data-testid="nav-mobile-toggle" onClick={() => setOpen((v) => !v)}
          className="md:hidden text-ink" aria-label="Menu">
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.div initial={{ height: 0, opacity: 0 }} animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }} className="md:hidden bg-paper border-b border-ink/10 overflow-hidden">
            <div className="px-6 py-5 flex flex-col gap-4">
              {LINKS.map((l) => (
                <a key={l.href} href={l.href} onClick={() => setOpen(false)}
                  className="text-base font-medium text-ink/80">{l.label}</a>
              ))}
              <Link to="/estimate" onClick={() => setOpen(false)}
                className="bg-ink text-paper px-5 py-3 text-center font-semibold">Free Estimate</Link>
              <a href={CONTACT.phoneHref} data-testid="nav-phone-mobile" onClick={() => setOpen(false)}
                className="flex items-center justify-center gap-2 border-2 border-rust text-rust px-5 py-3 font-display font-bold text-lg">
                <Phone size={18} className="fill-rust" /> {CONTACT.phone}
              </a>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
};
